<template>
  <div class="container-wrapper">
    <div class="table-wrapper">
      <div class="px-4 font-semibold dark:text-white">Dashboard</div>
      <div class="card-body">
        <fwb-alert type="success">
          Selamat Datang <strong> {{ this.userFullName }}.</strong>
        </fwb-alert>
        <!-- <div v-if="userLevel == 'admin' || userLevel == 'kepala'">
          <button
            v-if="openRegister == 0"
            type="button"
            v-on:click="this.confirmLaunch()"
            :disabled="this.loading"
            class="mt-4 w-full bg-green-400 text-white p-2 rounded-md hover:bg-green-800 focus:outline-none focus:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-900 transition-colors duration-300"
          >
            <font-awesome-icon
              v-if="isLoading"
              icon="circle-notch"
              :spin="loading"
            />
            Luncurkan Aplikasi
          </button>
          <button
            v-if="openRegister == 1"
            type="button"
            v-on:click="this.pauseLaunch()"
            :disabled="this.loading"
            class="mt-4 w-full bg-red-400 text-white p-2 rounded-md hover:bg-red-800 focus:outline-none focus:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-900 transition-colors duration-300"
          >
            <font-awesome-icon
              v-if="isLoading"
              icon="circle-notch"
              :spin="loading"
            />
            Aktifkan Maintenance Mode
          </button>
        </div> -->
        <div class="grid md:grid-cols-2 md:gap-4 py-2">
          <div class="py-1 col-span-2 md:col-span-1 flex">
            <div class="py-1">
              <button
                type="button"
                @click="this.fetchData()"
                class="btn btn-icon btn-gray"
              >
                <font-awesome-icon
                  :icon="['fas', 'arrows-rotate']"
                  :spin="isLoading"
                />
              </button>
            </div>
            <div class="py-1 col-span-2 md:col-span-1 flex">
              <InputSelect
                placeholder="Pilih Periode"
                v-model="filter.periode"
                :options="listPeriode"
                @change="this.fetchData()"
              />
            </div>
          </div>
        </div>
        <div class="grid grid-cols-1 gap-5 lg:grid-cols-5">
          <div
            class="bg-white overflow-hidden shadow rounded-lg dark:bg-gray-900"
          >
            <div class="px-4 py-5 sm:p-6">
              <dl>
                <dt
                  class="text-sm leading-5 font-medium text-gray-500 truncate dark:text-gray-400"
                >
                  Jumlah Mahasiswa
                </dt>
                <dd
                  class="mt-1 text-3xl leading-9 font-semibold text-green-600 dark:text-green-400"
                >
                  {{ count_mahasiswa }}
                </dd>
              </dl>
            </div>
          </div>
          <div
            class="bg-white overflow-hidden shadow rounded-lg dark:bg-gray-900"
          >
            <div class="px-4 py-5 sm:p-6">
              <dl>
                <dt
                  class="text-sm leading-5 font-medium text-gray-500 truncate dark:text-gray-400"
                >
                  Jumlah Pengajuan
                </dt>
                <dd
                  class="mt-1 text-3xl leading-9 font-semibold text-green-600 dark:text-green-400"
                >
                  {{ count_pengajuan }}
                </dd>
              </dl>
            </div>
          </div>
          <div
            class="bg-white overflow-hidden shadow rounded-lg dark:bg-gray-900"
          >
            <div class="px-4 py-5 sm:p-6">
              <dl>
                <dt
                  class="text-sm leading-5 font-medium text-gray-500 truncate dark:text-gray-400"
                >
                  Pengajuan Proses
                </dt>
                <dd
                  class="mt-1 text-3xl leading-9 font-semibold text-green-600 dark:text-green-400"
                >
                  {{ data_status.jumlah_proses_verifikasi }}
                </dd>
              </dl>
            </div>
          </div>
          <div
            class="bg-white overflow-hidden shadow rounded-lg dark:bg-gray-900"
          >
            <div class="px-4 py-5 sm:p-6">
              <dl>
                <dt
                  class="text-sm leading-5 font-medium text-gray-500 truncate dark:text-gray-400"
                >
                  Pengajuan Ditolak
                </dt>
                <dd
                  class="mt-1 text-3xl leading-9 font-semibold text-green-600 dark:text-green-400"
                >
                  {{ data_status.jumlah_pengajuan_ditolak }}
                </dd>
              </dl>
            </div>
          </div>
          <div
            class="bg-white overflow-hidden shadow rounded-lg dark:bg-gray-900"
          >
            <div class="px-4 py-5 sm:p-6">
              <dl>
                <dt
                  class="text-sm leading-5 font-medium text-gray-500 truncate dark:text-gray-400"
                >
                  Pengajuan Diterima
                </dt>
                <dd
                  class="mt-1 text-3xl leading-9 font-semibold text-green-600 dark:text-green-400"
                >
                  {{ data_status.jumlah_pengajuan_diterima }}
                </dd>
              </dl>
            </div>
          </div>
        </div>
        <div v-show="!isLoading">
          <div
            class="mt-4 relative overflow-x-auto shadow-md rounded-md sm:rounded-lg"
          >
            <div ref="barKecamatan" class="rounded-lg"></div>
          </div>
          <div
            class="mt-4 relative overflow-x-auto shadow-md rounded-md sm:rounded-lg"
          >
            <div
              ref="barKampus"
              class="rounded-lg"
              style="min-height: 200vh"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="./dashboard-page.js"></script>